import isEmail from 'validator/lib/isEmail';

import {
  FieldValidation,
  VALIDATION_MESSAGE_EMAIL_REQUIRED,
  VALIDATION_MESSAGE_EMAIL_NOT_VALID,
} from 'webclient.constants';

const validateEmailFormat = (value: string): FieldValidation => {
  if (!value) {
    return VALIDATION_MESSAGE_EMAIL_REQUIRED;
  }

  if (!isEmail(value.trim(), { ignore_max_length: true })) {
    return VALIDATION_MESSAGE_EMAIL_NOT_VALID;
  }
  return true;
};

export default validateEmailFormat;
